import AudienceLists from "./AudienceLists.vue";

export * from "./audienceLists.data";
export * from "./audienceLists.types";

export default AudienceLists;
